import { create } from "zustand";

const useSettingsStore = create((set) => ({
    settings: [], //jobtypes
    setSettings: (value) => set((state) => ({...state, settings: value}))
}));

export default useSettingsStore;
